import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://yinyue-beikebao.impultienda.ar/checkout';
const PASSTHROUGH_KEYS = ['fbclid', 'gclid', 'ttclid', 'wbraid', 'gbraid'];
/** Carries ad-click ids and utm parameters from the landing URL to the checkout. */
export function withTracking(url: string): string {
  if (typeof window === 'undefined' || url.startsWith('#')) return url;
  try {
    const source = new URLSearchParams(window.location.search);
    const target = new URL(url);
    source.forEach((value, key) => {
      if ((key.startsWith('utm_') || PASSTHROUGH_KEYS.includes(key)) && !target.searchParams.has(key)) {
        target.searchParams.set(key, value);
      }
    });
    return target.toString();
  } catch {
    return url;
  }
}
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = '立即取得音樂備課寶™',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  const finalHref = isInternal ? href : withTracking(href);
  return <a href={finalHref} onClick={event => {
    if (!isInternal) event.currentTarget.href = withTracking(href);
  }} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-red-700 px-5 py-4 text-center text-sm font-semibold text-white shadow-lg shadow-red-700/30 transition-[transform,background-color] duration-150 ease-out hover:bg-red-800 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/30 sm:px-9 sm:py-5 sm:text-base ${className}`} data-id="element-69" data-mp="39yhs4117e5il">
      <span data-id="element-70" data-mp="6iaofuisg89t">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-71" data-mp="6hj2zciwnqx9" />
    </a>;
}